import Tasks from '../../controllers/tasks';
import { getMasterLinksByTaskId } from '../../helpers/ganttHelpers';

export default instance => {
  instance.attachEvent('onBeforeTaskMove', (id, parent, tindex) => Tasks.onBeforeTaskMove(id, parent, tindex));
  // instance.attachEvent('onBeforeTaskChanged', (id, mode, oldTaskData) => {
  //   // TODO replace
  //   const taskData = instance.getTask(id);
  //   const isChangedStart = oldTaskData.start_date.valueOf() !== taskData.start_date.valueOf();
  //   const isChangedEnd = oldTaskData.end_date.valueOf() !== taskData.end_date.valueOf();

  //   if (isChangedStart) {
  //     const children = instance.getChildren(taskData.parent).filter(childID => instance.getTask(childID).type !== instance.config.types.button);
  //     const predecessors = instance._getPredecessors(taskData, children.length > 1);

  //     if (predecessors.length === 1) {
  //       return false;
  //     }
  //   }

  //   const mastersData = getMasterLinksByTaskId(instance, taskData.id);
  //   let shouldDisable = false;
  //   let alreadyBlockedByStart = false;

  //   mastersData.forEach(masterData => {
  //     switch (masterData.linkType) {
  //     case instance.config.links.finish_to_start:
  //     case instance.config.links.start_to_start:
  //       if (isChangedStart) {
  //         shouldDisable = true;
  //       }
  //       if (isChangedEnd) {
  //         alreadyBlockedByStart = true;
  //         shouldDisable = false;
  //       }
  //       break;
  //     case instance.config.links.finish_to_finish:
  //     case instance.config.links.start_to_finish:
  //       if (isChangedEnd && !alreadyBlockedByStart) {
  //         shouldDisable = true;
  //       }
  //       break;
  //     }
  //   });

  //   return !shouldDisable;
  // });
};
